// 商品・買い物袋・ログインの開閉で、背景固定と元のボタンへのフォーカス復帰を共通にする
export function initHomeDialogs($) {
  const dialogs = Array.from(document.querySelectorAll('.p-home-dialog'));
  let lastOpener = null;

  function openDialog(dialog, opener) {
    if (!dialog) return;
    if (opener && !opener.closest('dialog')) lastOpener = opener;
    dialogs.forEach(function (other) { if (other !== dialog && other.open) other.close(); });
    if (!dialog.open) {
      dialog.showModal();
      // 商品名から内容を確認できるようにし、画像が隠れるスクロールや閉じるボタンの強調を防ぐ。
      const initialFocus = dialog.querySelector('.js-home-dialog-initial-focus');
      if (initialFocus) initialFocus.focus({ preventScroll: true });
    }
    $('body').addClass('is-fixed');
  }

  $(dialogs).on('close', function () {
    $(this).find('input[type="password"]').val('');
    const anotherOpen = dialogs.some(dialog => dialog.open);
    $('body').toggleClass('is-fixed', anotherOpen);
    if (!anotherOpen && lastOpener?.isConnected) lastOpener.focus({ preventScroll: true });
  }).on('click', function (event) {
    if (event.target !== this) return;
    const rect = this.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
  });
  $('.js-home-dialog-open').on('click', function (event) {
    const dialog = document.getElementById(this.getAttribute('aria-controls'));
    if (!dialogs.includes(dialog)) return;
    event.preventDefault();
    openDialog(dialog, this);
  });
  $('.js-home-dialog-close').on('click', function () { this.closest('dialog').close(); });

  // 認証に失敗して戻ったときは、エラーを表示するダイアログを自動で開く
  const errorDialog = dialogs.find(dialog => dialog.hasAttribute('data-open-on-load'));
  if (errorDialog) openDialog(errorDialog);

  return { openDialog };
}
